/**
 * Split a selection into catalogue codes and the therapist's own words.
 *
 * The picker works in one flat list, because that is how a therapist thinks
 * about it — the ways they work, whoever coined the word for them. Storage
 * keeps the two apart, because only the catalogue half is filterable.
 */
export function partitionTags(values: string[], catalogue: readonly string[]) {
    const known: string[] = [];
    const custom: string[] = [];
    for (const value of values) {
        (catalogue.includes(value) ? known : custom).push(value);
    }
    return { known, custom };
}
